import { page, type FeatureRoutes } from "@/app/feature";

// The POC lab: throwaway prototypes to compare, never a feature. It exists in mock builds only (the preview
// site, `VITE_MOCK=1 npm run dev`): a real build folds the test away and ships neither the route nor its code.
export const routes: FeatureRoutes = {
  public:
    import.meta.env.VITE_MOCK === "1"
      ? [
          { path: "lab/card-pocs", lazy: page(() => import("./card-pocs/LabPage")) },
          { path: "lab/holo", lazy: page(() => import("./holo/HoloLabPage")) },
        ]
      : [],
};
